<div>
  <p class="title-cart">{{ "cart" | translate }}</p>
  <p class="desc-cart">
    {{
      (router.url.includes("sport") ? "Sport.ReviewMatchesCart" : "review-cart")
        | translate
    }}
  </p>
  <div *ngFor="let item of ticketService?.bookTicket?.getValue()?.items">
    <app-cart-item [item]="item"></app-cart-item>
  </div>
</div>
